import { MyHttpClient } from '../http-client';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { resolveIncentiveSlotTitleOptions, SlotTitleOption, } from '../create-incentive/slot-title-options';
import * as i0 from "@angular/core";
import * as i1 from "../http-client";
export var BASE_URL = {
    OLD_DASHBOARD: environment.rapido_dashboard,
};
var SharedService = /** @class */ (function () {
    function SharedService(http) {
        this.http = http;
        this.getCities = environment.server + '/api/get/cities';
        this.getServices = environment.server + '/api/get/services';
        this.getShifts = environment.server + '/api/get/shifts';
        this.getModes = environment.server + '/api/modes/city';
        this.getModesByServiceDetailIds = environment.server + '/api/modes/serviceDetailIds';
        this.getZones = environment.server + '/api/get/zones';
        this.getBulkZones = environment.server + '/api/get/bulk/zones';
        this.getRules = environment.server + '/api/get/rules';
        this.getRuleDetails = environment.server + '/api/get/rules/details/';
        this.incentiveMetrics = environment.server + '/api/incentive/metrics';
        this.getTranslations = environment.server + '/api/translations';
        this.STATE = {
            CREATE: 'create',
            EDIT: 'edit',
            VIEW: 'view',
            DUPLICATE: 'duplicate'
        };
        this.INCENTIVE_TYPES = [
            'Daily',
            'Weekly Fixed',
            'Adhoc'
        ];
        this.INCENTIVE_TYPES_MAP = {
            "daily": "Daily",
            "weekly": "Weekly",
            "adhoc": "Adhoc",
        };
        this.SEGMENT_TYPES = [
            'UHP D UHO',
            'HP D UHO',
            'HP D HO',
            'MP D UHO',
            'MP D HO',
            'MP D MO',
            'MP D LO',
            'LP D UHO',
            'LP D HO',
            'LP D MO',
            'LP D LO',
            'MP Intra UHO',
            'MP Intra HO',
            'MP Intra MO',
            'MP Intra LO',
            'LP Intra UHO',
            'LP Intra HO',
            'LP Intra MO',
            'LP Intra LO',
            'LP Inter UHO',
            'LP Inter HO',
            'LP Inter MO',
            'LP Inter LO',
            'CUSTOM'
        ];
        this.SUBSCRIPTION_VALIDITY_TYPES = ["earnings", "rides", "unlimited"];
    }
    SharedService.prototype.fetchTranslations = function (locales, keys) {
        var queryparams = "?";
        locales.forEach(function (locale) { return queryparams += "&locales[]=" + locale; });
        keys.forEach(function (key) { return queryparams += "&keys[]=" + key; });
        return this.http.get(this.getTranslations + queryparams).pipe(catchError(this.handleError));
    };
    SharedService.prototype.getIncentiveMetrics = function (incentiveId) {
        return this.http.get(this.incentiveMetrics + "?incentiveId=" + incentiveId)
            .pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchStatesAndCities = function () {
        return this.http.get(environment.server + "/api/geolayers/states-and-cities").pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchAllServiceDetails = function () {
        return this.http.get(environment.server + "/api/service-details").pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchSubscriptionServiceOptions = function (cityId, modeId) {
        return this.http.get(environment.server + "/api/subscription/service-options?cityId=" + encodeURIComponent(cityId) + "&modeId=" + encodeURIComponent(modeId)).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchCities = function () {
        return this.http.get(this.getCities).pipe(map(function (response) {
            // Transform new response structure to match old structure
            var transformedResponse = {
                info: {
                    status: "success",
                    message: "All cities found"
                },
                data: {
                    cities: (response.geolayers || []).map(function (geolayer) {
                        return {
                            active: geolayer.active,
                            _id: geolayer.cityId,
                            displayName: geolayer.properties && geolayer.properties.displayName ? geolayer.properties.displayName : geolayer.name,
                            shortName: geolayer.properties && geolayer.properties.shortName ? geolayer.properties.shortName : geolayer.name,
                            name: geolayer.properties && geolayer.properties.cityName ? geolayer.properties.cityName : geolayer.name,
                        };
                    }),
                    count: response.count || 0
                }
            };
            return transformedResponse;
        }), catchError(this.handleError));
    };
    SharedService.prototype.fetchServices = function (id) {
        var payload = {
            city: id
        };
        return this.http.post(this.getServices, payload).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchServicesWithMode = function (cityId) {
        return this.http.get(environment.server + "/api/" + cityId + "/services").pipe(catchError(this.handleError));
    };
    SharedService.prototype.cityService = function (cityId) {
        return this.http.get(environment.server + "/api/serviceDetail/city/" + cityId).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchDashboardConfig = function () {
        return this.http.get(environment.server + "/api/dashboard-config").pipe(catchError(this.handleError));
    };
    /**
     * Normalizes GET /api/dashboard-config JSON to the `data` object create-slab stores as `dashboardConfig`.
     */
    SharedService.prototype.parseDashboardConfigResponse = function (res) {
        if (res && res.data) {
            return res.data;
        }
        return null;
    };
    /** v2 slot title presets from dashboard-config; optional per `service._id` overrides. */
    SharedService.prototype.fetchIncentiveSlotTitleOptionsFromDashboardConfig = function (serviceIds) {
        var _this = this;
        if (serviceIds === void 0) { serviceIds = []; }
        return this.fetchDashboardConfig()
            .toPromise()
            .then(function (res) {
            return resolveIncentiveSlotTitleOptions(_this.parseDashboardConfigResponse(res), serviceIds);
        })
            .catch(function () { return resolveIncentiveSlotTitleOptions(null, serviceIds); });
    };
    SharedService.prototype.isSlabCategoryConfiguredForMode = function (dashboardConfig, modeId, category) {
        if (!category || !dashboardConfig || !modeId) {
            return false;
        }
        var categoryData = dashboardConfig.earningModelsForModeAndSlabCategory[modeId][category];
        return categoryData && categoryData.length > 0;
    };
    /**
     * Union of every earning model listed under `earningModelsForModeAndSlabCategory`
     * (same map create-slab reads in setEarningModels via cfg[mode][category]).
     */
    SharedService.prototype.collectAllEarningModelsFromDashboardConfig = function (dashboardConfig) {
        var cfg = dashboardConfig && dashboardConfig.earningModelsForModeAndSlabCategory;
        if (!cfg || typeof cfg !== 'object') {
            return [];
        }
        var unique = new Set();
        Object.keys(cfg).forEach(function (modeId) {
            var byCategory = cfg[modeId];
            if (!byCategory || typeof byCategory !== 'object') {
                return;
            }
            Object.keys(byCategory).forEach(function (category) {
                var models = byCategory[category];
                if (Array.isArray(models)) {
                    models.forEach(function (m) {
                        if (m != null && String(m).trim() !== '') {
                            unique.add(String(m));
                        }
                    });
                }
            });
        });
        return Array.from(unique).sort();
    };
    SharedService.prototype.getUserSelectorDetails = function (ruleId) {
        return this.http.get(this.getRuleDetails + ruleId).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchShifts = function (city) {
        return this.http.get(this.getShifts + '/' + city).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchModes = function (cityId) {
        return this.http.get(this.getModes + '/' + cityId).pipe(map(function (response) {
            return {
                info: response.info || { status: "success", message: "Got modes" },
                data: {
                    modes: (response.data && response.data.modes) || []
                }
            };
        }), catchError(this.handleError));
    };
    SharedService.prototype.fetchModesByServiceDetailIds = function (serviceDetailIds) {
        var params = new URLSearchParams();
        serviceDetailIds.forEach(function (id) { return params.append("serviceDetailIds[]", id); });
        return this.http.get(this.getModesByServiceDetailIds + "?" + params.toString()).pipe(map(function (response) {
            return {
                info: response.info || { status: "success", message: "Got modes" },
                data: {
                    modes: (response.data && response.data.modes) || [],
                }
            };
        }), catchError(function (error) {
            console.error('Error fetching modes by serviceDetailIds:', error);
            return throwError(error);
        }));
    };
    SharedService.prototype.fetchRules = function (city, service, shift, userType, selectorType) {
        if (selectorType === void 0) { selectorType = ""; }
        var queryparams = '?userType=' + userType + '&city=' + city;
        if (shift) {
            queryparams += '&shift=' + shift;
        }
        if (service) {
            queryparams += '&service=' + service;
        }
        if (selectorType) {
            queryparams += '&type=' + selectorType;
        }
        return this.http.get(this.getRules + queryparams).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchZones = function (city, groupId) {
        var queryparams = '?cityId=' + city + '&groupId=' + groupId;
        return this.http.get(this.getZones + queryparams).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchBulkZones = function (zoneIds) {
        var payload = {
            zoneIds: zoneIds
        };
        return this.http.post(this.getBulkZones, payload).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchLimits = function (payload) {
        return this.http.post(environment.server + "/api/limit-store/limits", payload)
            .pipe(catchError(this.handleError));
    };
    SharedService.prototype.createLimit = function (payload) {
        return this.http.post(environment.server + "/api/limit-store/limits/create", payload)
            .pipe(catchError(this.handleError));
    };
    SharedService.prototype.createShift = function (shiftData) {
        var payload = {
            cities: shiftData.cities,
            modeId: shiftData.mode,
            shiftName: shiftData.shiftName,
            isDefault: shiftData.isDefault
        };
        return this.http.post(environment.server + '/api/shift', payload).pipe(catchError(this.handleError));
    };
    SharedService.prototype.createSlab = function (slabData) {
        return this.http.post(environment.server + '/api/slab', slabData).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchSlabs = function (payload) {
        return this.http.post(environment.server + '/api/get/slabs', payload).pipe(catchError(this.handleError));
    };
    SharedService.prototype.getSlab = function (id) {
        return this.http.get(environment.server + "/api/slab/" + id).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchGeoSlabConfig = function (cityId, layerId, layerType) {
        if (layerType === void 0) { layerType = 'hotspot'; }
        var params = new URLSearchParams();
        params.set('cityId', cityId);
        params.set('layerId', layerId);
        params.set('layerType', layerType);
        return this.http.get(environment.server + "/api/geo-slab-config?" + params.toString())
            .pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchLayers = function (cityId, featureType, groupIds, categories) {
        if (featureType === void 0) { featureType = 'hotspot'; }
        if (groupIds === void 0) { groupIds = []; }
        if (categories === void 0) { categories = []; }
        var params = new URLSearchParams();
        params.set('cityId', cityId);
        params.set('featureType', featureType);
        (groupIds || []).filter(Boolean).forEach(function (groupId) { return params.append('groupId', groupId); });
        (categories || []).filter(Boolean).forEach(function (category) { return params.append('category', category); });
        return this.http.get(environment.server + "/api/layers?" + params.toString()).pipe(map(function (response) {
            var rows = (response && (response.hotspots || response.geolayers)) || [];
            return {
                layers: rows.map(function (row) {
                    var properties = row && row.properties ? row.properties : {};
                    return {
                        id: row.id || row._id,
                        name: properties.name || properties.displayName || row.name || row.id,
                        featureType: row.featureType || featureType,
                        active: row.active !== false
                    };
                }),
                count: response && response.count != null ? response.count : rows.length
            };
        }), catchError(this.handleError));
    };
    SharedService.prototype.fetchCaptainEarningsShifts = function (cityId, modeId, isDefault) {
        var defaultParam = "&isDefault=" + (isDefault ? 'true' : 'false');
        return this.http.get(environment.server + "/api/captain-earnings/shifts?cityId=" + cityId + "&modeId=" + modeId + defaultParam)
            .pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchMicroCorridors = function (payload) {
        return this.http.post(environment.server + "/api/microcorridors", payload).pipe(catchError(this.handleError));
    };
    SharedService.prototype.fetchFlatCommissionDeductions = function (payload) {
        var params = new URLSearchParams();
        params.set('cityId', payload.cityId);
        payload.serviceDetailIds.forEach(function (id) { return params.append('serviceDetailIds', id); });
        return this.http.get(environment.server + "/api/commission-deductions?" + params.toString())
            .pipe(catchError(this.handleError));
    };
    SharedService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    SharedService.prototype.redirectToDashbaord = function (url) {
        var redirectUrl = "" + BASE_URL.OLD_DASHBOARD + url;
        var token = this.readCookie('token');
        window.open(redirectUrl + "?token=" + token);
    };
    SharedService.prototype.readCookie = function (name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    };
    SharedService.ngInjectableDef = i0.defineInjectable({ factory: function SharedService_Factory() { return new SharedService(i0.inject(i1.MyHttpClient)); }, token: SharedService, providedIn: "root" });
    return SharedService;
}());
export { SharedService };
